import { Button } from "./Button";
import "./upload-closed-card.css";

export interface UploadClosedCardProps {
  /** Back to the receipts list — the single `[ Закрити ]` action (variant A). */
  onClose: () => void;
}

/**
 * Race-condition info card shown inside `receipt-upload` when
 * `createReceipt` returns 409 `conflict_reason: "trip_closed"` — the trip
 * was closed by another participant between the FAB tap and the create
 * call (components.md §6.5). Info tone, NOT danger, and never a retry:
 * retrying a closed trip just 409s again. The backend guard runs before
 * presign/PUT, so nothing was uploaded — hence the reassurance line.
 */
export function UploadClosedCard({ onClose }: UploadClosedCardProps) {
  return (
    <div
      className="wp-upload-closed"
      role="alertdialog"
      aria-labelledby="wp-upload-closed-title"
      data-testid="upload-closed-card"
    >
      <p id="wp-upload-closed-title" className="wp-upload-closed__title">
        <span aria-hidden="true" className="wp-upload-closed__icon">
          ✓
        </span>
        Поїздку вже закрито
      </p>
      <p className="wp-upload-closed__body">
        Поки ти вибирав фото, поїздку закрили. Щоб додати чек, спершу відкрий
        її в налаштуваннях.
      </p>
      <p className="wp-upload-closed__reassure">Фото не завантажено.</p>
      <Button onClick={onClose} autoFocus data-testid="upload-closed-close">
        Закрити
      </Button>
    </div>
  );
}
